import { LayoutGrid, Mail, BellRing, Users, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { DESPRE_POINTS, SCHOOLS } from "../../data/smartContent";

const ICONS = { LayoutGrid, Mail, BellRing, Users };

export const SmartDespre = () => (
  <section id="despre" data-testid="section-despre" className="scroll-mt-20 bg-slate-50 py-14 lg:py-20">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <div className="max-w-3xl">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-isic">Despre proiect</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl font-semibold leading-[1.15] text-ink">
            Ce este ISIC Smart Campus
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            ISIC Smart Campus este un sistem dezvoltat special pentru instituțiile de învățământ, este implementat
            într-o serie de țări europene în peste 100 de școli, licee și universități și oferă următoarele avantaje:
          </p>
        </Reveal>
      </div>

      <div className="mt-10 grid gap-x-16 gap-y-2 sm:grid-cols-2">
        {DESPRE_POINTS.map((point, i) => {
          const Icon = ICONS[point.icon];
          return (
            <Reveal key={i} delay={i * 0.06}>
              <div data-testid={`whatis-point-${i}`} className="flex items-start gap-5 border-t border-slate-200 py-6">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-isic/10 text-isic">
                  <Icon size={20} strokeWidth={1.8} />
                </span>
                <p className="text-[15px] leading-relaxed text-slate-700 pt-1.5">{point.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-10 rounded-2xl border border-slate-200 bg-white p-7 lg:p-9">
          <p className="text-[15px] text-slate-700 leading-relaxed max-w-3xl">
            În România, proiectul se află la început și a fost deja implementat în școli și licee precum:
          </p>
          <ul className="mt-6 grid gap-x-10 gap-y-3 sm:grid-cols-2">
            {SCHOOLS.map((school) => (
              <li key={school} className="flex items-start gap-3 text-[15px] text-slate-700 leading-snug">
                <MapPin size={17} strokeWidth={1.8} className="mt-0.5 shrink-0 text-isic" />
                {school}
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);
